import React, { useState, useRef, useEffect } from 'react';
import Loader from '../Loader/Loader';
import classes from './Canvas.module.css';
import { createMixLayout } from './mix-layout';

const loadImage = (part) => new Promise((resolve, reject) => {
  const image = new Image();
  image.onload = () => resolve(image);
  image.onerror = () => reject(new Error(`Could not load ${part.imgurl}`));
  image.src = `/static/images/${part.imgurl}`;
});

export const Canvas = ({ champData, headVal, head2Val, torsoVal, legsVal, isPixelMixer, isAsheTorso, isTopTen }) => {
  const canvasRef = useRef(null);
  const [result, setResult] = useState({ src: null, error: false });
  useEffect(() => {
    let cancelled = false;
    setResult({ src: null, error: false });
    const find = (value, type) => champData.find(p => `${p.id}_${type}` === value && p.type === (type === 'head2' ? 'head' : type));
    const layout = createMixLayout({
      head: find(headVal, 'head'), torso: find(torsoVal, 'torso'),
      legs: find(legsVal, 'legs'), head2: isAsheTorso ? find(head2Val, 'head2') : null, isPixelMixer,
    });
    if (!layout) return () => { cancelled = true; };
    Promise.all(layout.layers.map(layer => loadImage(layer.part))).then(images => {
      if (cancelled || !canvasRef.current) return;
      const canvas = canvasRef.current;
      canvas.width = layout.width;
      canvas.height = layout.height;
      const context = canvas.getContext('2d');
      context.imageSmoothingEnabled = !isPixelMixer;
      layout.layers.forEach((layer, i) => context.drawImage(images[i], layer.x, layer.y, layer.part.width, layer.part.height));
      const pixels = context.getImageData(0, 0, canvas.width, canvas.height);
      let left = canvas.width, top = canvas.height, right = -1, bottom = -1;
      for (let y = 0; y < canvas.height; y++) for (let x = 0; x < canvas.width; x++) {
        if (pixels.data[(y * canvas.width + x) * 4 + 3]) {
          left = Math.min(left, x); top = Math.min(top, y); right = Math.max(right, x); bottom = Math.max(bottom, y);
        }
      }
      if (right < 0) throw new Error('The selected mix is empty');
      const cropped = context.getImageData(left, top, right - left + 1, bottom - top + 1);
      canvas.width = cropped.width;
      canvas.height = cropped.height;
      context.putImageData(cropped, 0, 0);
      setResult({ src: canvas.toDataURL('image/png'), error: false });
    }).catch(() => { if (!cancelled) setResult({ src: null, error: true }); });
    return () => { cancelled = true; };
  }, [champData, headVal, head2Val, torsoVal, legsVal, isPixelMixer, isAsheTorso]);

  return <>
    <div id="canvasReplace">
      {result.src ? <img alt="generatedImage" className={isTopTen ? '' : classes.GeneratedImage} src={result.src} />
        : result.error ? <p role="alert">This mix could not be loaded. Please choose another part or try again.</p> : <Loader isTopTen={isTopTen} />}
    </div>
    <canvas ref={canvasRef} id="myCanvas" className={classes.Canvas} />
  </>;
};
